import { MODULES, ACTIONS } from '../../api/roleApi';
import './PermissionMatrix.css';

export default function PermissionMatrix({ permissions, onChange, readOnly }) {
  const perm = permissions || {};

  const isChecked = (mod, action) => (perm[mod] || []).includes(action);

  const toggle = (mod, action) => {
    if (readOnly) return;
    const current = perm[mod] || [];
    const next = current.includes(action)
      ? current.filter(a => a !== action)
      : [...current, action];
    onChange({ ...perm, [mod]: next });
  };

  const toggleRowAll = (mod) => {
    if (readOnly) return;
    const current = perm[mod] || [];
    const allSelected = ACTIONS.every(a => current.includes(a));
    onChange({ ...perm, [mod]: allSelected ? [] : [...ACTIONS] });
  };

  const toggleColAll = (action) => {
    if (readOnly) return;
    const allSelected = MODULES.every(m => (perm[m.key] || []).includes(action));
    const updated = { ...perm };
    for (let i = 0; i < MODULES.length; i++) {
      const m = MODULES[i];
      const cur = updated[m.key] || [];
      if (allSelected) {
        updated[m.key] = cur.filter(a => a !== action);
      } else if (!cur.includes(action)) {
        updated[m.key] = [...cur, action];
      }
    }
    onChange(updated);
  };

  return (
    <div className="perm-matrix">
      <table className="perm-matrix__table">
        <thead>
          <tr>
            <th className="perm-matrix__th perm-matrix__th--left">Module</th>
            {ACTIONS.map(a => (
              <th key={a} className="perm-matrix__th">
                {readOnly ? a : (
                  <div className="perm-matrix__col-header">
                    <span>{a}</span>
                    <button className="perm-matrix__all-btn" onClick={() => toggleColAll(a)} title={`Toggle all ${a}`}>all</button>
                  </div>
                )}
              </th>
            ))}
            {!readOnly && <th className="perm-matrix__th">All</th>}
          </tr>
        </thead>
        <tbody>
          {MODULES.map(m => (
            <tr key={m.key} className="perm-matrix__row">
              <td className="perm-matrix__td">
                <span className="perm-matrix__mod-name">{m.label}</span>
              </td>
              {ACTIONS.map(a => (
                <td key={a} className="perm-matrix__td perm-matrix__td--center">
                  <input
                    type="checkbox"
                    className="perm-matrix__check"
                    checked={isChecked(m.key, a)}
                    onChange={() => toggle(m.key, a)}
                    disabled={readOnly}
                  />
                </td>
              ))}
              {!readOnly && (
                <td className="perm-matrix__td perm-matrix__td--center">
                  <button className="perm-matrix__all-btn" onClick={() => toggleRowAll(m.key)}>
                    {ACTIONS.every(a => isChecked(m.key, a)) ? 'none' : 'all'}
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
